import React, { FC } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import colors from '../../../../themes/main-colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    legendTypeText: {
      color: colors.black,
    },
    lengendWrap: {
      marginBottom: theme.spacing(1.25),
    },
  }),
);

interface Props {
  svgIcon: any;
  iconDescription: string;
}

const LegendIconListItem: FC<Props> = (props: Props) => {
  const { svgIcon: SvgIcon, iconDescription } = props;
  const classes = useStyles();

  return (
    <Grid container alignItems="center" className={classes.lengendWrap}>
      <SvgIcon />
      <Grid item component="span">
        <Typography variant="h6" className={classes.legendTypeText}>
          {iconDescription}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default LegendIconListItem;
